import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ComplaintProfesionalService } from 'src/app/services/services.index';
import { ProfesionalDTO } from 'src/app/models/ProfesionalDTO';
import { ToastrService } from 'ngx-toastr';
import { Config } from 'src/app/constants/config';
import { Util } from 'src/app/util/util';
import {ComplaintDTO} from '../../../models/ComplaintDTO';

@Component({
  selector: 'previus-complaints-modal',
  templateUrl: './previus-complaints-modal.component.html',
  styleUrls: ['./previus-complaints-modal.component.scss']
})
export class PreviusComplaintModalComponent implements OnInit {

  @Input() complaints: ComplaintDTO[];

  
  util = Util;

  constructor(
    public _complaintProfesionalService: ComplaintProfesionalService,
    private _toastr: ToastrService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    console.log(this.complaints);
  }

  
}
